import { Modal, useModals } from 'almanac-ui/Modal'
import { Header } from './components/Header'
import { useState } from 'react'
import { TemplateModal } from 'components/Templates/TemplateModal'
import { useDebounce } from 'hooks/useDebounce'
import Styles from './TemplatesV2.module.scss'
import { IFilters, TemplatesModalV2Props } from './Types'
import { ASPECT_RATIOS, AspectRatioKey, DesignChannelMarketplace, DesignChannels } from 'components/NewFileModal/Types'
import { TemplatesGrid } from './components/TemplatesGrid'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { MobileHeader } from './components/MobileHeader'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const TemplatesModalV2 = ({
  width,
  height,
  designChannel,
  types,
  styles,
  categories,
  disabledFilters,
  onUse,
  onClose,
  onSelect,
}: TemplatesModalV2Props) => {
  const channel = designChannel as string as DesignChannelMarketplace
  const { openModal, closeModal } = useModals()
  const { isMobile } = useResponsiveDesign()

  const aspectRatioKey =
    (Object.keys(ASPECT_RATIOS) as AspectRatioKey[]).find(
      (key: AspectRatioKey) =>
        DesignChannels[key] === designChannel &&
        ASPECT_RATIOS[key].height === height &&
        ASPECT_RATIOS[key].width === width,
    ) || 'instagram-square-post'

  const [filters, setFilters] = useState<IFilters>({
    types:
      types ||
      new Set(
        Object.values(DesignChannelMarketplace).includes(channel) &&
        channel !== DesignChannelMarketplace.LinkedInProfilePicture &&
        channel !== DesignChannelMarketplace.FacebookProfilePicture &&
        channel !== DesignChannelMarketplace.YoutubeProfilePicture &&
        channel !== DesignChannelMarketplace.TwitterProfilePicture &&
        channel !== DesignChannelMarketplace.WhatsAppSticker
          ? ['marketplace']
          : ['social media'],
      ),
    styles: styles || 'all',
    categories: categories || 'all',
    query: '',
    aspectRatioKey,
  })
  const debouncedFilters = { ...filters, query: useDebounce(filters.query ?? '', 500) }

  return (
    <Modal.Root onPressOutside={closeModal} size="lg" bodyClassName={Styles.modalRoot}>
      <ResponsiveDesign.Desktop>
        <div className={Styles.headerContainer}>
          <Header
            heading="Find the right template for you"
            filters={filters}
            onFilterChange={setFilters}
            minHeight={200}
            hiddenFilters={isMobile ? ['format'] : []}
            disabledFilters={disabledFilters || ['format']}
          />
        </div>
      </ResponsiveDesign.Desktop>
      <ResponsiveDesign.Mobile>
        <MobileHeader
          filters={filters}
          onClose={onClose}
          onFilterChange={setFilters}
          isFormatEditable={false}
          disabledFilters={disabledFilters || ['format']}
        />
      </ResponsiveDesign.Mobile>
      <div className={Styles.bodyContainer}>
        <TemplatesGrid
          onSelect={(templateId) => {
            if (onSelect) {
              onSelect(templateId)
              return
            }
            openModal(TemplateModal, {
              initialTemplateId: templateId,
              onPressOutside: closeModal,
              onConfirm: () => onUse(templateId),
              initialAspectRatioKey: aspectRatioKey,
              isAspectRatioKeyEditable: false,
              isSharingAllowed: false,
            })
          }}
          filters={debouncedFilters}
          aspectRatioKey={aspectRatioKey}
          useCompactUI={isMobile}
        />
      </div>
    </Modal.Root>
  )
}
